import React, { useCallback, useEffect, useState, useRef, createContext, useMemo } from 'react';

import { FormHandles } from '@unform/core';

import { Box, Grid, Divider, Flex, Heading, Button as ChakraButton } from '@chakra-ui/react';

import {
  TextInput,
  Unform,
  Button,
  Clients,
  AutocompleteInput,
  Loading,
  DateInput,
  SelectInput,
} from 'components';
import { IUsersData } from 'types/users';
import { usersValidationSchema } from 'yupSchemas/users';
import { RouteComponentProps } from 'react-router';
import { IPermissionValue } from 'types/test';
import { AccordionRoles } from './components';
import { createUser } from 'services/createUser';
import { getUserData } from 'services/getUserData';
import { openNotification } from 'utils/notification';
import {
  permissionTypeOptions,
  userTypeOptions,
  userTypeOptionsForClientAdm,
  permissionTypeValues,
  userTypeValues,
  userTypeClient,
} from 'constants/users';
import { formatDateToUs } from 'utils/date';
import { editUser } from 'services/editUser';
import { changeStatusUser } from 'services/changeStatusUser';
import { getRolesList } from 'services/rolesList';
import { IRoles } from 'types/roles';
import { checkPermission } from 'utils/authentication';
import useEventBus from 'hooks/useEventBus';
import { WarningMessage } from 'components/WarningMessage';
import { useDisclosure } from '@chakra-ui/hooks';
import { ModalActiveOrInactiveUser } from './components/ModalActiveOrInactiveUser';
import { getLoggedUser } from 'utils/storage';
import { useParams } from 'react-router-dom';

export const RolesCtx = createContext({
  roles: [] as IRoles[],
});

export const NewUser: React.FC<RouteComponentProps<{ id?: string }>> = ({ history, match }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const params = useParams();

  const eventBus = useEventBus();
  const userID = match.params.id || false;

  const idLogged = getLoggedUser().id;

  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', userID ? 'Detalhes do usuário ' : 'Novo Usuário');
  }, [userID]);
  const isClient = useMemo(() => {
    return checkPermission({ onlyClient: true });
  }, []);
  const [isSaving, setIsSaving] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [previousPath, ,] = useState<any>(localStorage.getItem('url') ?? '');
  const [route, ,] = useState<boolean>(previousPath.includes('page=0'));
  // eslint-disable-next-line no-unneeded-ternary
  const [isEditing, setIsEditing] = React.useState(route ? true : false);

  const [userType, setUserType] = useState<number>(userTypeValues.client);
  const [permissionType, setPermissionType] = useState<string>();
  const [user, setUser] = useState<IUsersData>();
  const formRef = useRef<FormHandles>(null);
  const [roles, setRoles] = useState<IRoles[]>([]);
  const [typeUser, setTypeUser] = useState<string | number | boolean>('');

  const handleGetDataUserLogged = async () => {
    try {
      const userLogged = await getUserData(String(idLogged));
      const dataUserLogged = userLogged.data;
      setTypeUser(dataUserLogged.employeeDanielLaw);
    } catch {}
  };

  const handleGetData = async (roles: IRoles[]) => {
    if (!userID) return;
    try {
      setIsLoading(true);
      const response = await getUserData(userID);

      const rl = roles.reduce((acc, i) => {
        acc.push(...i.roles);
        return acc;
      }, [] as IRoles['roles']);
      response.data.roles = rl.map(i => {
        const role = response.data.roles?.find(e => typeof e !== 'boolean' && e.id === i.id);
        if (role) return role;
        return false;
      });
      setUser(response.data);

      let typeUser = 0;

      if (response.data.employeeDanielLaw === 'DANIEL_LAW') {
        typeUser = userTypeValues.admin;
      } else if (response.data.employeeDanielLaw === 'CLIENTE_DANIEL_LAW') {
        typeUser = userTypeValues.client;
      } else {
        typeUser = userTypeValues.client_adm;
      }

      setUserType(typeUser);
      setIsLoading(false);
      setPermissionType(
        response.data.temporaryAccess
          ? permissionTypeValues.temporary
          : permissionTypeValues.permanent,
      );
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = useCallback(
    async (formData: IUsersData) => {
      try {
        setIsSaving(true);

        const tempRolesArray: IPermissionValue[] = [];

        formData?.roles?.forEach(obj => {
          if (obj) {
            tempRolesArray.push(obj);
          }
        });

        tempRolesArray.push({ id: 2, name: 'ROLE_USER' });

        let type = 0;

        if (formData.admin === userTypeValues.admin) {
          type = 1;
        } else if (formData.admin === userTypeValues.client) {
          type = 0;
        } else if (formData.admin === userTypeValues.client_adm) {
          type = 2;
        }

        const formDataAdmin = Number(formData.admin);

        const createData = {
          ...formData,
          id: userID ? parseInt(userID) : null,
          employeeDanielLaw: type,
          roles: formDataAdmin === userTypeValues.client ? tempRolesArray : undefined,
          temporaryAccess:
            formDataAdmin === userTypeValues.client
              ? formData.permissionType === permissionTypeValues.temporary
              : false,
          expirationDate: !formDataAdmin
            ? formData.permissionType === permissionTypeValues.temporary
              ? formatDateToUs(formData.expirationDate || '')
              : null
            : null,
          client: isClient ? formData.client : formData.client,
        };

        if (
          formData.admin === userTypeValues.admin ||
          formData.admin === userTypeValues.client_adm
        ) {
          if (createData) {
            delete createData.roles;
          }
        }

        const onlyRoleUser = createData.roles;
        if (formData.admin === userTypeValues.client) {
          if (onlyRoleUser?.length === 1) {
            // eslint-disable-next-line array-callback-return
            onlyRoleUser.map(item => {
              if (item.name === 'ROLE_USER') {
                return openNotification('Selecione pelo menos uma permissão!', 'error');
              }
            });
            return;
          }
        }

        if (!userID) {
          await createUser(createData);
          openNotification('Usuário criado com sucesso!', 'success');
        } else {
          await editUser(userID, createData);
          openNotification('Usuário editado com sucesso!', 'success');
        }
        history.push('/users');
      } catch (error) {
        console.log(error);
      } finally {
        setIsSaving(false);
      }
    },
    [permissionType, userType, userID, isClient],
  );
  const handleChangePermissionType = useCallback(
    (value: { optionValue: string }) => {
      setPermissionType(value.optionValue);
    },
    [permissionType],
  );

  const handleChangeUserType = useCallback((value?: string | number | any[]) => {
    if (typeof value === 'number') setUserType(value);
  }, []);

  const handleChangeStatus = async (userId: number, enabled: boolean) => {
    try {
      await changeStatusUser(userId, enabled);
      history.push('/users');
      openNotification('Status alterado com sucesso');
    } catch (error) {}
  };
  useEffect(() => {
    const getRoles = async () => {
      try {
        const { data: rolesList } = await getRolesList();

        // Ordenando lista de permissões por Id
        const sortedRolesList = rolesList.map(role => ({
          ...role,
          roles: role.roles.sort((a, b) => {
            return a.description < b.description ? -1 : a.name > b.name ? 1 : 0;
          }),
        }));

        setRoles(sortedRolesList);
        return sortedRolesList;
      } catch (err) {
        return [];
      }
    };
    getRoles().then(handleGetData);

    return () => {
      localStorage.removeItem('url');
    };
  }, []);

  useEffect(() => {
    handleGetDataUserLogged();
    return () => {
      localStorage.removeItem('url');
    };
  }, []);

  const admin = useMemo(() => {
    if (user?.id && user?.employeeDanielLaw) {
      if (user?.employeeDanielLaw === 'DANIEL_LAW') {
        return userTypeOptions[0];
      } else if (user?.employeeDanielLaw === 'CLIENTE_DANIEL_LAW') {
        return userTypeOptions[2];
      } else {
        return userTypeOptions[1];
      }
    }
  }, [isClient, user?.client]);

  return (
    <Box w="100%">
      <Box
        m="0 auto"
        width="848px"
        maxHeight="100%"
        padding="2rem"
        background="#fff"
        borderRadius="10px"
        boxShadow={'0px 0px 15px rgba(0, 0, 0, 0.25);'}
      >
        {userID && (isLoading || !user) ? (
          <Loading />
        ) : (
          <Box padding="2rem" background="#fff" borderRadius="10px">
            <Unform
              onSubmit={handleSubmit}
              formRef={formRef}
              initialData={{
                name: user?.name,
                email: user?.email,
                client:
                  user?.client ||
                  (getLoggedUser().client && {
                    id: getLoggedUser().client,
                    name: getLoggedUser().clientName,
                  }),
                username: user?.username,
                jobTitle: user?.jobTitle,
                department: user?.department,
                expirationDate: user?.expirationDate
                  ? new Date(user.expirationDate.replaceAll('-', '/')).toLocaleDateString()
                  : undefined,
                permissionType:
                  user &&
                  permissionTypeOptions.find(permission => {
                    const type = user.temporaryAccess
                      ? permissionTypeValues.temporary
                      : permissionTypeValues.permanent;
                    return permission.value === type;
                  }),
                roles: user?.roles,
                admin: admin,
              }}
              validationSchema={usersValidationSchema(isClient)}
            >
              {isClient ? (
                <Box hidden={isClient}>
                  <Box flex={1}>
                    <SelectInput
                      name="admin"
                      optionLabel="label"
                      optionValue="value"
                      label="Perfil de Acesso"
                      options={userTypeClient}
                      defaultValues={[userTypeClient]}
                      disabled
                    />
                  </Box>
                </Box>
              ) : (
                <Box>
                  <Box flex={1}>
                    <AutocompleteInput
                      label="Perfil de Acesso"
                      name="admin"
                      options={
                        typeUser === `CLIENTE_ADMINISTRADOR`
                          ? userTypeOptionsForClientAdm
                          : userTypeOptions
                      }
                      onChange={handleChangeUserType}
                      disabled={!!userID}
                      isReadOnly={!!userID}
                    />
                  </Box>
                </Box>
              )}

              {userType === 1 ? (
                <Box hidden={true}>
                  <Clients
                    disableNewClient={isClient || !!getLoggedUser().client || !!userID}
                    disabled={isClient || !!getLoggedUser().client || (!isEditing && !!userID)}
                  />
                </Box>
              ) : (
                <Box hidden={isClient}>
                  <Clients
                    disableNewClient={isClient || !!getLoggedUser().client || !!userID}
                    disabled={isClient || !!getLoggedUser().client || !!userID}
                  />
                </Box>
              )}
              <Grid templateColumns="repeat(3, 1fr)" gridGap="1rem">
                <Box flex={1}>
                  <TextInput
                    name="username"
                    placeholder="Digite aqui"
                    label="Usuário"
                    disabled={!!userID}
                  />
                </Box>
                <Box flex={1}>
                  <TextInput
                    name="name"
                    placeholder="Digite aqui"
                    label="Nome"
                    disabled={!isEditing && !!userID}
                  />
                </Box>
                <Box flex={1}>
                  <TextInput
                    name="email"
                    placeholder="Digite aqui"
                    label="Email"
                    disabled={!isEditing && !!userID}
                  />
                </Box>
              </Grid>
              <Grid templateColumns="repeat(2, 1fr)" gridGap="1rem">
                <Box flex={1}>
                  <TextInput
                    name="jobTitle"
                    placeholder="Digite aqui"
                    label="Cargo"
                    disabled={!isEditing && !!userID}
                  />
                </Box>
                <Box flex={1}>
                  <TextInput
                    name="department"
                    placeholder="Digite aqui"
                    label="Departamento"
                    disabled={!isEditing && !!userID}
                  />
                </Box>
              </Grid>
              <Divider mr="-2rem" />

              <Grid templateColumns="repeat(1, 1fr)" gridGap="1rem">
                {userType === userTypeValues.client && (
                  <Flex flexDirection={'column'}>
                    <Heading m="1rem 0" size="md" as="h3" width={'100%'}>
                      Permissões
                    </Heading>
                    <Flex gridGap={'1rem'}>
                      <Box flex={1}>
                        {!!userID && user?.temporaryAccess && (
                          <AutocompleteInput
                            label="Tipo"
                            name="permissionType"
                            options={permissionTypeOptions}
                            onSelectOption={handleChangePermissionType}
                            disabled={!isEditing && !!userID}
                          />
                        )}

                        {!!userID && !user?.temporaryAccess && (
                          <AutocompleteInput
                            label="Tipo"
                            name="permissionType"
                            options={permissionTypeOptions}
                            onSelectOption={handleChangePermissionType}
                            disabled
                          />
                        )}

                        {!user && (
                          <AutocompleteInput
                            label="Tipo"
                            name="permissionType"
                            options={permissionTypeOptions}
                            onSelectOption={handleChangePermissionType}
                            disabled={!isEditing && !!userID}
                          />
                        )}
                      </Box>

                      <Box flex={1}>
                        {permissionType === permissionTypeValues.temporary && (
                          <DateInput
                            name="expirationDate"
                            disabled={!isEditing && !!userID}
                            label="Data de Validade"
                          />
                        )}
                      </Box>
                    </Flex>
                    {permissionType === permissionTypeValues.temporary && (
                      <WarningMessage
                        text="O tempo máximo para o acesso temporário é de 15 dias"
                        width="60%"
                      />
                    )}
                  </Flex>
                )}
              </Grid>
              <Divider mb="1rem" />
              {userType === userTypeValues.client && (
                <>
                  <RolesCtx.Provider value={{ roles }}>
                    <AccordionRoles disabled={!isEditing && !!userID} />
                  </RolesCtx.Provider>
                  <Divider m="1rem" />
                </>
              )}

              {userID && !isEditing ? (
                <Flex
                  display={isEditing ? 'none' : 'flex'}
                  justifyContent={'space-between'}
                  gap={2}
                >
                  <Button
                    leftIcon={{ name: 'newPencil', marginRight: 'inherit', size: 1.3 }}
                    onClick={() => setIsEditing(true)}
                    type="button"
                    variant="primary"
                    outline
                  >
                    Editar Usuário
                  </Button>
                  <Button
                    leftIcon={{ name: 'trashed', size: 1, marginRight: 'inherit' }}
                    type="button"
                    variant="danger"
                    // outline
                    // onClick={() => handleChangeStatus(user?.id as number, !user?.enabled)}
                    onClick={onOpen}
                  >
                    {user?.enabled ? 'Desativar Usuário' : 'Ativar Usuário'}
                  </Button>
                </Flex>
              ) : (
                <Flex justifyContent="space-between" gap={2}>
                  <ChakraButton
                    color="brand.primary"
                    border="2px solid"
                    borderColor="brand.primary"
                    paddingX="25px"
                    type="reset"
                    onClick={() => {
                      // eslint-disable-next-line no-extra-boolean-cast
                      if (!!params) {
                        history.goBack();
                      } else if (isEditing) {
                        history.goBack();
                      } else {
                        setIsEditing(false);
                      }
                    }}
                    variant="cancel"
                  >
                    Cancelar
                  </ChakraButton>
                  <Button type="submit" isLoading={isSaving}>
                    Salvar
                  </Button>
                </Flex>
              )}
              <ModalActiveOrInactiveUser
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
                user={user}
                handleChangeStatus={handleChangeStatus}
                isLoading={isLoading}
                isSaving={isSaving}
              />
            </Unform>
          </Box>
        )}
      </Box>
    </Box>
  );
};
